import { IMobileFloatStatusConfig, IMobileFloatStatusManager } from './mobile-float-status-manager.interface';
import styles from './style.less';

const SCREEN_PADDING = 10;

/**
 * 移动端手势悬浮框
 */
export class MobileFloatStatusManager implements IMobileFloatStatusManager {
    private statusContainer: HTMLDivElement|null;

    public show(config: IMobileFloatStatusConfig = {}) {
        const statusContainer = this.getContainer();
        const { top = 0, left = 0, message = '', height = 34, fixElementSize = false, width } = config;
        statusContainer.style.height = `${height}px`;
        if (typeof message === 'string') {
            statusContainer.innerText = message;
        } else {
            statusContainer.appendChild(message);
        }
        const {
            width: rectWidth,
            height: rectHeight,
        } = statusContainer.getBoundingClientRect();
        let fixedTop = fixElementSize ? top - (rectHeight / 2) : top;
        let fixedLeft = fixElementSize ? left - (rectWidth / 2) : left;
        if (fixedTop < SCREEN_PADDING) fixedTop = SCREEN_PADDING;
        if (fixedLeft < SCREEN_PADDING) fixedLeft = SCREEN_PADDING;
        const bodyClientWidth = document.body.clientWidth;
        if (left > bodyClientWidth - SCREEN_PADDING - (rectWidth / 2)) {
            fixedLeft = bodyClientWidth - rectWidth - SCREEN_PADDING;
        }

        statusContainer.style.top = `${fixedTop}px`;
        statusContainer.style.left = `${fixedLeft}px`;
        if (width) {
            statusContainer.style.width = `${width}px`;
        }
    }

    public hide() {
        this.removeElement();
    }

    private getContainer() {
        if (this.statusContainer) {
            return this.statusContainer;
        }
        return this.createElement();
    }

    private createElement(): HTMLDivElement {
        const statusContainer = document.createElement('div');
        statusContainer.className = styles.statusContainer;
        this.statusContainer = statusContainer;
        document.body.appendChild(statusContainer);
        return statusContainer;
    }

    private removeElement() {
        if (this.statusContainer) {
            document.body.removeChild(this.statusContainer);
            this.statusContainer = null;
        }
    }
}
